module.exports = __webpack_public_path__ + "static/media/img105.9fd39cca.png";